import React from 'react';
import { useLang } from '../i18n';

/**
 * Warns that a date range overflowed its Firestore cap, so the numbers on
 * screen are computed from a PARTIAL slice.
 *
 * A dashboard that is confidently wrong is worse than one that is visibly
 * degraded — without this the KPIs just quietly describe the most recent N
 * orders while looking like they describe the whole period.
 *
 * Renders nothing when the range fit, so it is safe to mount unconditionally.
 */
export function TruncationBanner({ info }) {
  const { t } = useLang();
  if (!info?.truncated) return null;
  return (
    <div className="td__warn-banner" role="status">
      ⚠️ {t('trunc.warn', { kept: info.kept.toLocaleString(), limit: info.limit.toLocaleString() })}
    </div>
  );
}
